import { formatDashboardMinutesFromApi } from '@/utils/date/date-time'

const DURATION_MINUTES_FIELDS = new Set([
  'total_utilization_time',
  'total_non_utilization_time',
])

/** Campos de tempo do totalizer/grupo: valor numérico em minutos. */
export function isDurationMinutesField(dataField: string | null | undefined): boolean {
  return Boolean(dataField && DURATION_MINUTES_FIELDS.has(dataField))
}

/**
 * Formata valor para exibição (labels/tooltips/KPI).
 * Tempos continuam em minutos na geometria do gráfico; só o texto muda para d/h/min.
 */
export function formatWidgetMetricValue(
  value: number,
  dataField: string,
  unit = '',
): string {
  if (isDurationMinutesField(dataField)) {
    return formatDashboardMinutesFromApi(value)
  }

  const rounded = Number(value).toFixed(2)
  return unit ? `${rounded} ${unit}` : rounded
}

/** Unidade exibida ao lado do valor; vazia quando o tempo já inclui d/h/min. */
export function resolveWidgetDisplayUnit(dataField: string | null | undefined, unit = ''): string {
  if (isDurationMinutesField(dataField)) return ''
  return unit
}
